import React, { useEffect } from 'react'
import { css } from '@emotion/core'
import * as ReportModel from '@/models/report'
import {
  AdditionalFormInputBlock,
  FormContainer,
  FormInputBlock,
  FormInputRadioWrapper,
} from '@/components/molecules/reports-manager/form-container'
import { Select } from '@/components/atoms/select'
import { Select as AntSelect } from 'antd'
import { Controller, UseFormReturn, useWatch } from 'react-hook-form'
import { ReservationNoteCategory } from '@/models/reservation/reservation-note'
import { useTranslation } from 'react-i18next'
import { DateField } from '@/components/molecules/date-field'
import { SalesSubjectSelectBox } from './sales-subject-selecte-box'
import { ReportFormType } from '@/features/report-manager/report-manager-slice'

export const DailyReportForm: React.FC<{ formReturn: UseFormReturn<ReportFormType, any> }> = props => {
  const { t } = useTranslation()

  const { control, handleSubmit, setValue } = props.formReturn
  const watchType = useWatch({ control, name: 'type' })

  useEffect(() => {
    if (!ReportModel.dailyReportTypes.includes(watchType)) {
      setValue('type', ReportModel.dailyReportTypes[0])
    }
  }, [])

  return (
    <FormContainer onSubmit={handleSubmit}>
      <FormInputBlock title="レポート種類">
        <Controller
          name="type"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select value={value} onChange={onChange} customStyle={css({ paddingBottom: 0, width: 290 })}>
              {ReportModel.dailyReportTypes.map(type => (
                <AntSelect.Option key={type} value={type}>
                  {ReportModel.ReportTypeNames[type]}
                </AntSelect.Option>
              ))}
            </Select>
          )}
        />
      </FormInputBlock>

      <FormInputBlock title="対象日">
        <Controller
          name="date"
          control={control}
          render={({ field: { onChange, value } }) => <DateField value={value} onChange={v => onChange(v?.format('YYYY-MM-DD'))} />}
        />
      </FormInputBlock>

      <FormInputBlock title="出力形式">
        <Controller
          name="format"
          control={control}
          render={({ field: { onChange, value } }) => (
            <FormInputRadioWrapper value={value} items={ReportModel.formatRadioItems} onChange={onChange} />
          )}
        />
      </FormInputBlock>

      {ReportModel.enabledTax.includes(watchType) && (
        <FormInputBlock title="税表示">
          <Controller
            name="isIncludeTax"
            control={control}
            render={({ field: { onChange, value } }) => (
              <FormInputRadioWrapper value={value} items={ReportModel.taxRadioItems} onChange={onChange} />
            )}
          />
        </FormInputBlock>
      )}

      {ReportModel.enabledSubjectSelectTypes.includes(watchType) && (
        <AdditionalFormInputBlock>
          <FormInputBlock title="表示項目">
            <Controller
              name="subjectCodes"
              control={control}
              render={({ field: { onChange, value } }) => (
                <SalesSubjectSelectBox
                  value={value}
                  onChange={onChange}
                  history={ReportModel.getStoredSearchSubjectHistory(ReportModel.ReportTypes.dailyOperations)}
                />
              )}
            />
          </FormInputBlock>

          <FormInputBlock title="出力メモ">
            <Controller
              name="noteCategory"
              control={control}
              render={({ field: { onChange, value } }) => (
                <FormInputRadioWrapper
                  value={value}
                  items={[
                    { value: ReservationNoteCategory.Front, label: t(`reservationNote.${ReservationNoteCategory.Front}`) },
                    { value: ReservationNoteCategory.Cleaning, label: t(`reservationNote.${ReservationNoteCategory.Cleaning}`) },
                    { value: ReservationNoteCategory.Meal, label: t(`reservationNote.${ReservationNoteCategory.Meal}`) },
                  ]}
                  onChange={onChange}
                />
              )}
            />
          </FormInputBlock>
        </AdditionalFormInputBlock>
      )}
    </FormContainer>
  )
}
